import React, { useEffect, useState } from "react";
import { IconContext } from "react-icons";
import { FaApple, FaFacebook, FaGoogle, FaChevronRight } from "react-icons/fa";
import { IoCaretBack } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import colors from "../config/colors";
import { useDispatch, useSelector } from "react-redux";
import apiClient, { setAuthToken } from "../api/apiClient";
import { login } from "../redux/counterSlice";

import { toast } from "react-toastify";

export default () => {
  let loginState = {
    email: "",
    password: "",
  };
  useEffect(() => {
    document.title = "RollingAdz: Sign in" || "Default Title";
  }, []);
  const navigate = useNavigate();
  const [loading, setloading] = useState(false);
  const [showPassword, setShowPassword] = useState(true);
  const [loginData, setLoginData] = useState(loginState);

  const [message, setMessage] = useState({ text: "", color: "" });
  const handleChange = (key, value) => {
    setLoginData({ ...loginData, [key]: value });
  };

  function resetErrors() {
    setMessage({ text: "", color: "" });
  }
  const dispatch = useDispatch();
  const { isLoggedIn, userType } = useSelector((state) => state.auth);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // if (loginData.password.length < 6)
    //   return setMessage({
    //     text: "Password should be atleast 6 characters",
    //     color: "danger",
    //   });
    setloading(true)
    const result = await apiClient.post("/authentication/login/", loginData);
    setloading(false)
    if (result.ok) {
      setAuthToken(result.data?.token);
      dispatch(
        login({
          token: result.data?.token,
          userId: result.data?.user_id,
          userType: result.data?.account_type,
        })
      );
      handleNavigate(result.data?.account_type);
    } else {
      const errorMessage = result.data?.message || "An error occurred";
      console.log(errorMessage, "errorMessage");
      toast.error(errorMessage);
    }
  };

  function handleNavigate(accountType) {
    if (accountType === 0) {
      navigate("/advertiser-account");
    } else if (accountType === 1) {
      navigate("/designeraccount");
    } else if (accountType === 2) {
      navigate("/vehicleowneraccount");
    } else if (accountType === 3) {
      navigate("/installeraccount");
    } else if (accountType === 4) {
      navigate("/photographeraccount");
    }
  }

  return (
    <div>
      {/* Signup button popup */}
      <div className="main_2 d-flex justify-content-center align-items-center py-5">
        <div className="signin-box p-2 rounded-3 col-md-7">
          <div onClick={() => navigate(-1)}>
            <IoCaretBack size={35} color={colors.primary} />
          </div>
          <form onSubmit={handleSubmit}>
            {/* <h1 className="display-1 text-secondary h1 text-center"><i className="bi bi-truck" /></h1> */}
            <div className="login-form col-md-10 mx-auto">
              <div className=" login-head d-flex flex-column align-items-center justify-content-center">
                <Link to={"/"}>
                  <div className="logo" style={{ width: "10rem" }}>
                    <img
                      width={"100%"}
                      src={require("../assets/img/rolling-ads-logo.png")}
                      alt=""
                      className=" mw-100"
                    />
                  </div>
                </Link>
                <ul
                  className="nav nav-pills mb-3 w-75 rounded-pill fs-2 text-white"
                  id="pills-tab"
                  role="tablist"
                >
                  <li className="nav-item w-50" role="presentation">
                    <button
                      // onClick={() => navigate("/signin")}
                      className="nav-link active text-white w-100 rounded-pill p-3"
                      id="pills-sigin-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-signin"
                      type="button"
                      role="tab"
                      aria-controls="pills-signin"
                      aria-selected="true"
                    >
                      Sign In 
                    </button>
                  </li>
                  <li className="nav-item w-50" role="presentation">
                    <button
                      className="nav-link text-white w-100 rounded-pill p-3"
                      id="pills-signup-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-signup"
                      type="button"
                      role="tab"
                      aria-controls="pills-signup"
                      aria-selected="false"
                      onClick={() => navigate("/signUpPopup")}
                    >
                      Sign Up
                    </button>
                  </li>
                </ul>
              </div>
              {/* <div className="icon d-flex align-items-center justify-content-around blue-clr pb-4">
                <FaGoogle size={45} />
                <FaFacebook size={45} />
                <FaApple size={45} />
              </div> */}
              <input
              required
                type="email"
                value={loginData.email}
                onChange={(e) => handleChange("email", e.target.value)}
                placeholder="Email"
                className="form-control input shadow-none bg-transparent rounded-0 py-2 px-0 my-3 mx-0 border border-primary border-bottom-2 border-start-0 border-top-0 border-end-0 fs-5"
              />
              <div className="position-relative">
                <input
                required
                  value={loginData.password}
                  onChange={(e) => handleChange("password", e.target.value)}
                  className="form-control input shadow-none bg-transparent rounded-0 py-2 ps-0 pe-4 my-3 mx-0 border border-primary border-bottom-2 border-start-0 border-top-0 border-end-0 fs-5"
                  type={showPassword ? "password" : "text"}
                  name
                  id
                  placeholder="Password"
                />
                <button
                  type="button"
                  className="show-password bg-transparent border-0 position-absolute end-0 top-0 lh-lg fs-5"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <i className="bi bi-eye-fill" />
                  ) : (
                    <i class="bi bi-eye-slash-fill" />
                  )}
                </button>
              </div>
              {/* {message.text && (
                <div className={`bg-${message.color} p-1 m-1`}>
                  <span>{message.text}</span>
                </div>
              )} */}
              <div className="d-flex flex-wrap justify-content-between align-items-center">
                <div className="d-flex">
                  <input
                    type="checkbox"
                    name
                    id="remember"
                    className="form-check-input p-2"
                  />
                  <label htmlFor="remember" className="fs-5 px-2 lh-base">
                    Remember me
                  </label>
                </div>
                <Link to={"/forgot-password"} className="blue-clr fs-5">
                  Forgot Password?
                </Link>
              </div>
              {/* <p className="text-center blue-clr fs-4 pb-2">OR</p>
              <p className="text-center text-secondary fs-5 pb-2">
                Sign Up with
              </p>
              <div className="icon d-flex align-items-center justify-content-around blue-clr pb-4">
                <FaGoogle size={45} />
                <FaFacebook size={45} />
                <FaApple size={45} />
              </div> */}
              <div className="d-flex justify-content-center">
                <button
                  type="submit"
                  disabled={loading}
                  className="login-btn bg-blue rounded-pill text-white fs-3 border-0 px-5 lh-lg"
                >
                  {loading?"Login...":"Login"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

// function SignUp({ items }) {
//   const { navigate, type, setType } = items;

//   return (
//     <div
//       className="tab-pane fade"
//       id="pills-signup"
//       role="tabpanel"
//       aria-labelledby="pills-signup-tab"
//     >
//       {!type && (
//         <form action>
//           <div className=" row justify-content-center">
//             <div className="col-md-6">
//               <div className="py-3">
//                 <h5 className="text_color text-center">
//                   Become a Rolling Adz Advertiser
//                 </h5>
//                 <div className="d-flex justify-content-center">
//                   <button
//                     onClick={() => {
//                       setType(1);
//                     }}
//                     className="btn btn_bg px-5 rounded-pill"
//                     id="pills-signup-tab"
//                     data-bs-toggle="pill"
//                     data-bs-target="#pills-button"
//                     type="button"
//                     role="tab"
//                     aria-controls="pills-signup"
//                     aria-selected="false"
//                   >
//                     <h5>Advertiser</h5>
//                     <p>(Agencies & Companies)</p>
//                   </button>
//                 </div>
//               </div>

//               <div className="py-3">
//                 <h5 className="text_color text-center">
//                   Become a Rolling Adz Vendor
//                 </h5>
//                 <div className="d-flex justify-content-center">
//                   <button
//                     onClick={() => {
//                       setType(2);
//                     }}
//                     className="btn btn_bg px-5 rounded-pill"
//                     type="button"
//                   >
//                     <h5>Vendors</h5>
//                     <p>(Vehicle,Installer,etc.)</p>
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </form>
//       )}
//       {type == 1 && (
//         <form action>
//           <div className=" row justify-content-center">
//             <div className="col-md-6">
//               <h3 className="text_color text-center text-decoration-underline">
//                 Advertisers
//               </h3>
//               <div className="py-3">
//                 <h5 className="text_color text-center">Are you an agency?</h5>
//                 <div className="d-flex justify-content-center">
//                   <button
//                     style={{ width: "300px" }}
//                     onClick={() =>
//                       navigate("/signUpPopup", { state: { role: "AG" } })
//                     }
//                     className="btn btn_bg rounded-pill fs-3 px-5 lh-lg"
//                     id="pills-signup-tab"
//                     data-bs-toggle="pill"
//                     data-bs-target="#pills-button"
//                     type="button"
//                     role="tab"
//                     aria-controls="pills-signup"
//                     aria-selected="false"
//                   >
//                     Agency
//                   </button>
//                 </div>
//               </div>

//               <div className="py-3">
//                 <h5 className="text_color text-center">
//                   Are you a company direct?
//                 </h5>
//                 <div className="d-flex justify-content-center">
//                   <button
//                     style={{ width: "300px" }}
//                     onClick={() =>
//                       navigate("/signUpPopup", { state: { role: "CD" } })
//                     }
//                     className="btn btn_bg rounded-pill fs-3 px-5 lh-lg"
//                     type="button"
//                   >
//                     Company Direct
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </form>
//       )}
//       {type == 2 && (
//         <form action>
//           <h3 className="text_color text-center text-decoration-underline">
//             Vendors
//           </h3>

//           <div className=" row">
//             <div className="col-md-6">
//               <div className="py-3">
//                 <h5 className="text_color text-center">List your Vehicle!</h5>
//                 <div className="d-flex justify-content-center">
//                   <button
//                     onClick={() =>
//                       navigate("/signUpPopup", { state: { role: "VO" } })
//                     }
//                     className="btn btn_bg rounded-pill fs-3 px-5 lh-lg"
//                     type="button"
//                   >
//                     Vehicle Owner
//                   </button>
//                 </div>
//               </div>
//             </div>

//             <div className="col-md-6">
//               <div className="py-3">
//                 <h5 className="text_color text-center">
//                   Become a Rolling Adz Installer!
//                 </h5>
//                 <div className="d-flex justify-content-center">
//                   <button
//                     onClick={() =>
//                       navigate("/signUpPopup", { state: { role: "IN" } })
//                     }
//                     className="btn btn_bg rounded-pill fs-3 px-5 lh-lg"
//                     type="button"
//                   >
//                     Installer
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className=" row">
//             <div className="col-md-6">
//               <div className="py-3">
//                 <h5 className="text_color text-center">
//                   Become a Rolling Adz <br /> Designer!
//                 </h5>
//                 <div className="d-flex justify-content-center">
//                   <button
//                     onClick={() =>
//                       navigate("/signUpPopup", { state: { role: "DE" } })
//                     }
//                     className="btn btn_bg rounded-pill fs-3 px-5 lh-lg"
//                     id="pills-signup-tab"
//                     data-bs-toggle="pill"
//                     data-bs-target="#pills-button"
//                     type="button"
//                     role="tab"
//                     aria-controls="pills-signup"
//                     aria-selected="false"
//                   >
//                     Designer
//                   </button>
//                 </div>
//               </div>
//             </div>

//             <div className="col-md-6">
//               <div className="py-3">
//                 <h5 className="text_color text-center">
//                   Become a Rolling Adz Phototgrapher!
//                 </h5>
//                 <div className="d-flex justify-content-center">
//                   <button
//                     onClick={() =>
//                       navigate("/signUpPopup", { state: { role: "PH" } })
//                     }
//                     className="btn btn_bg rounded-pill fs-3 px-5 lh-lg"
//                     type="button"
//                   >
//                     Phototgrapher
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className=" d-flex justify-content-center">
//             <div>
//               <div className="py-3">
//                 <h5 className="text_color text-center">Other Vendor!</h5>
//                 <div className="d-flex justify-content-center">
//                   <button
//                     // onClick={()=>navigate('/signUpPopup',{state:{id:3}})}

//                     className="btn btn_bg rounded-pill fs-3 px-5 lh-lg"
//                     type="button"
//                     role="tab"
//                     aria-controls="pills-signup"
//                     aria-selected="false"
//                   >
//                     Other:
//                     <input
//                       type="text"
//                       className=" btn_bg"
//                       style={{ borderBottomWidth: 2 }}
//                     />
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </form>
//       )}
//     </div>
//   );
// }
